
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{'SCAN' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
  </button>
</div>
<div class="modal-body pt-0 px-0 pb-0">
  @if (active) {
    <app-qr-scanner-input #input (stopped)="closeModal()" (resetModal)="reset()"></app-qr-scanner-input>
  }
</div>
